import { AppStore } from "@/store/AppStore";
import { DeleteNoteSourceOperation } from "@/store/sync/operations/sources/DeleteNoteSourceOperation";
import { Uuid } from "@/domains/global/identifiers";

export const deleteNoteSource = async ({
  store,
  noteId,
  sourceId,
}: {
  store: AppStore;
  noteId: Uuid;
  sourceId: Uuid;
}) => {
  await new DeleteNoteSourceOperation({
    store,
    payload: {
      note_id: noteId,
      source_id: sourceId,
    },
  }).execute();
};
